const toPath = (path) => {
  if (!path) {
    return [];
  }

  if (Array.isArray(path)) {
    return path;
  }

  return String(path)
    .split(".")
    .filter(Boolean);
};

const setNestedValue = (state, path, value) => {
  const normalizedPath = toPath(path);
  if (!normalizedPath.length) {
    return;
  }

  const keys = normalizedPath.slice(0, -1);
  const lastKey = normalizedPath[normalizedPath.length - 1];
  const target = keys.reduce((current, key) => current?.[key], state);

  if (target && lastKey) {
    target[lastKey] = value;
  }
};

const hasOwn = (state, key) =>
  Object.prototype.hasOwnProperty.call(state || {}, key);

export function addAsyncCases(builder, thunk, options = {}) {
  const {
    dataKey = "data",
    loadingKey = ["ui", "loading"],
    clearErrorOnPending = true,
    clearErrorOnFulfilled = true,
    onPending,
    onFulfilled,
    onRejected,
  } = options;

  builder
    .addCase(thunk.pending, (state, action) => {
      state.status = "init";
      if (loadingKey) {
        setNestedValue(state, loadingKey, true);
      }
      if (clearErrorOnPending && hasOwn(state, "error")) {
        state.error = null;
      }
      if (onPending) {
        onPending(state, action);
      }
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.status = "idle";
      if (loadingKey) {
        setNestedValue(state, loadingKey, false);
      }
      if (clearErrorOnFulfilled && hasOwn(state, "error")) {
        state.error = null;
      }
      if (onFulfilled) {
        onFulfilled(state, action);
        return;
      }
      if (dataKey) {
        state[dataKey] = action.payload;
      }
    })
    .addCase(thunk.rejected, (state, action) => {
      state.status = "error";
      if (loadingKey) {
        setNestedValue(state, loadingKey, false);
      }
      if (hasOwn(state, "error")) {
        state.error = action.payload || action.error?.message || null;
      }
      if (onRejected) {
        onRejected(state, action);
      }
    });
}
